import type { ReactElement } from 'react';
import KrakenNotFound from '@fastnorth/kraken/components/not-found';
import { useTranslation } from 'react-i18next';

export type NotFoundProps = {
  message?: string;
  cerbiconUri?: string;
};

const NotFound = ({
  message,
  cerbiconUri = 'https://cdn.raceroster.com/assets/cerbicons/empty-404--forest.svg',
}: NotFoundProps): ReactElement => {
  const { t } = useTranslation('translation', { keyPrefix: 'karwa.error_ui' });
  return (
    <KrakenNotFound
      heading={t('are_you_lost')}
      description={message || t('the_url_you_are_looking_for')}
      image={{
        src: cerbiconUri,
        alt: t('are_you_lost'),
        variant: 'illustration',
      }}
    />
  );
};

export default NotFound;
